import React from 'react';
import './LoadingIndicator.css'; // We'll define the CSS next

const LoadingIndicator = ({ size = 40 }) => {
  return (
    <div
      className="loading-indicator mr-2"
      style={{ width: size, height: size }}
    />
  );
};

export default LoadingIndicator;
